import React from "react";

import IconButton from "@material-ui/core/IconButton";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

import { EMPTY_STRING } from "common/constants";

import useStyles from "./styles";

interface IProps {
  claimChange: number;
  classChange: number;
}

const THOUSAND_DIVISOR = 1000;

const ClassOrClaimChange = ({ claimChange, classChange }: IProps) => {
  const classes = useStyles();

  const shouldShowClaimChangeContent = [claimChange, !classChange].every(
    Boolean
  );
  const isChangeUp = classChange ? classChange > 0 : claimChange > 0;

  const arrowContent = isChangeUp ? (
    <ArrowUpwardIcon className={classes.upArrow} />
  ) : (
    <ArrowDownwardIcon className={classes.downArrow} />
  );

  const claimChangeContent = shouldShowClaimChangeContent
    ? `${Math.round((Math.abs(claimChange) / THOUSAND_DIVISOR) * 10) / 10}K`
    : EMPTY_STRING;

  return (
    <span className={classes.claimChangeContent}>
      <IconButton className={classes.arrowButton}>{arrowContent}</IconButton>
      {claimChangeContent}
    </span>
  );
};

export default React.memo(ClassOrClaimChange);
